export default __webpack_public_path__ + "dc7ec55d0ae684300765593ab6e8db7e.png";